import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { Pharmacy } from '../../models/pharmacy';

const getPharmacyIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Pharmacy>) => memoize((
        text: Undefinable<string>
    ) => {
        const keywords = (text || '').toLowerCase().split(' ').filter(x => x);
        return Object
            .keys(byId)
            .filter(x => {
                if (byId[x]!.fT_cols) {
                    const lower = byId[x]!.fT_cols!.toLowerCase();
                    return keywords.every(t => lower.indexOf(t) > -1);
                } else {
                    return false;
                }
            });
    })
);

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getLoadingHash: (
        state: State
    ): Dictionary<boolean> => state.loading,
    getPharmacy: (
        state: State,
        id: Undefinable<string>
    ): Undefinable<Pharmacy> => state.byId[id || ''],
    getPharmacyHash: (
        state: State
    ): Dictionary<Pharmacy> => state.byId,
    getPharmacyIds: (
        state: State,
        text: Undefinable<string>
    ): Undefinable<string[]> => getPharmacyIdsSelector(state)(text)
};
